//#region imports
import { SaveService } from '../../../../services/save.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { NgForm } from '@angular/forms';
import { SaveConfirmationDialogComponent } from '../save-confirmation-dialog/save-confirmation-dialog.component';
import { ContactDetails } from 'src/app/shared/model/save.model';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { AppConstants } from 'src/app/app.constants';
import { Globals } from 'src/app/services/globals';
//#endregion

@Component({
  selector: 'app-save-dialog',
  templateUrl: './save-dialog.component.html',
  styleUrls: ['./save-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SaveDialogComponent implements OnInit {
  //#region variables
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  code: string;
  dob: string;
  street: string;
  streetno:string;
  boxno: string;
  simulationOptionChk = false;
  contactDetails: ContactDetails;
  simulationToken: string;
  clientIdOrSimulationTokenPresent: boolean;
  emailpattern:any;
  //#endregion

  //#region variables
  constructor(
    private dialogRef: MatDialogRef<SaveDialogComponent>, private matDialog: MatDialog,
    private saveService: SaveService, private characteristicService: CharacteristicService,
    private globals: Globals) {
      dialogRef.disableClose = false;
     }

  ngOnInit() {
    this.clientIdOrSimulationTokenPresent = this.characteristicService.getClientIdOrSimulationTokenPresent();
    this.contactDetails = this.saveService.getContactDetails();
    if (this.contactDetails) {
      this.firstName = this.contactDetails.FirstName;
      this.lastName = this.contactDetails.LastName;
      this.email = this.contactDetails.EmailAddress;
      this.phone = this.contactDetails.Telephone;
      this.code = this.contactDetails.PostalCode;
      this.dob = this.contactDetails.DateofBirth;
      this.street = this.contactDetails.StreetName;
      this.streetno = this.contactDetails.StreetNumber;
      this.boxno = this.contactDetails.BoxNumber;
    }
    this.emailpattern = AppConstants.EmailIdRegexPattern;
  }

  onSubmit(myForm: NgForm) {
    let saveRequest;
    if (myForm.valid) {
      // console.log('valid form');
      this.globals.trackPageActivity += ';' + 'SAVE';
      saveRequest = this.getSaveRequest(myForm);
      this.globals.sendSimulationMail = false;
      this.saveService.saveSimulation(saveRequest, 'ManualSave').subscribe((data) => {
        this.dialogRef.close(true);
        this.setContactDetails(saveRequest);
        this.saveService.setSimulationToken(data.Tocken);
        this.saveService.setProspectNumber(data.CRMProspect);
        this.saveService.setShortToken(data.shortTocken);
        const saveConfirmationDetails = this.getSaveConfirmationDetails(saveRequest, data.Tocken);
        this.matDialog.open(SaveConfirmationDialogComponent, { data: saveConfirmationDetails });
        // console.log('test');
      });
    } else {
      // console.log('invalid form');
    }
  }

  getSaveRequest(myForm) {
    if (this.clientIdOrSimulationTokenPresent) {
      return {
        firstName: this.firstName, lastName: this.lastName, email: myForm.value.email,
        phone: myForm.value.phone, code: myForm.value.code, optionSalesContact: myForm.value.simulationOptionChk
      };
    } else {
      return myForm.value;
    }
  }

  getSaveConfirmationDetails(saveRequest, tocken) {
    return {
      firstName: saveRequest.firstName + ' ' + saveRequest.lastName,
      email: saveRequest.email,
      phone: saveRequest.phone,
      code: saveRequest.code,
      Token: tocken
    };
  }

  setContactDetails(saveRequest) {
    const contactData: ContactDetails = {
      FirstName: saveRequest.firstName,
      Name: '',
      LastName: saveRequest.lastName,
      EmailAddress: saveRequest.email,
      Telephone: saveRequest.phone,
      PostalCode: saveRequest.code,
      DateofBirth: this.dob,
      StreetName: this.street,
      StreetNumber: this.streetno,
      BoxNumber:this.boxno
    };
    this.saveService.setContactDetails(contactData);
  }

  onClose() {
    this.dialogRef.close(true);
  }
  //#endregion
}
